'use client';

import type { ReactNode } from 'react';
import { Toaster } from 'sonner';
import { AuthedProviders } from '@/components/AuthedProviders';
import { AuthBootstrap } from '@/components/AuthBootstrap';
import { TelegramBackButtonSetup } from '@/components/TelegramBackButtonSetup';
import { AuthGate } from '@/components/AuthGate';
import { ScreenPage } from '@/components/ScreenPage';
import { GlobalSubscriptions } from '@/components/GlobalSubscriptions';
import { GlobalAchievementSheet } from '@/components/GlobalAchievementSheet';
import { ChickenManager } from '@/components/ChickenManager';

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <AuthedProviders>
      <TelegramBackButtonSetup />
      <AuthGate>
        <AuthBootstrap>
          {/* GlobalSubscriptions mounts the achievement Centrifugo
              subscription once per session; achievement_unlocked toasts
              fire from any screen. */}
          <GlobalSubscriptions />
          <GlobalAchievementSheet />
          <ChickenManager />
          <ScreenPage>{children}</ScreenPage>
        </AuthBootstrap>
      </AuthGate>
      {/* sonner Toaster — single mount, dark theme to match TMA chrome */}
      <Toaster position="top-center" theme="dark" richColors />
    </AuthedProviders>
  );
}
